import _ from 'underscore'
import CreateClassViewTemplate from '../templates/create-class.tpl'
import messages from '../messages'
import Alert from '../helpers/alert'
import Backbone from 'backbone'

const CreateClassView = Backbone.View.extend({
    tagName: 'div',
    id: 'form-view',
    schoolView: null,
    inputSettings: 'autocomplete=off autocorrect=off autocapitalize=off spellcheck=false',
    events: {
        'click .close': 'close',
        'click .submit': 'addClass',
    },
    initialize(options) {
        if (options && options.schoolView) {
            this.schoolView = options.schoolView
        }

        this.template = _.template(CreateClassViewTemplate)
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))
        return this
    },
    addClass() {
        const name = this.$el.find('#classname').val()

        new Promise((resolve, reject) => {
            // checks if name is blank
            if (name.trim() === '') {
                reject(messages.MSG_CLASS_NAME_BLANK)
            }
            resolve(messages.MSG_PASSWORDS_DONT_MATCH)
        })
            .then(() => this.model.create(name))
            .then(() => this.close())
            .catch(Alert)
    },
    close() {
        if (this.schoolView) {
            this.schoolView.render()
        } else {
            this.remove()
            this.unbind()
        }
    }
})

export default CreateClassView
